import { render, staticRenderFns } from "./AbstractType2.vue?vue&type=template&id=4e162866&scoped=true"
import script from "./AbstractType2.vue?vue&type=script&lang=js"
export * from "./AbstractType2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e162866",
  null
  
)

export default component.exports